var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmMuteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UmMute",
    transform: "translate(-30 -191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(30 191)",
    fill: "rgba(0,0,0,0.3)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(39.436 200.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M9.967,15.9H5.061a.555.555,0,0,0-.561.54v7.554a.555.555,0,0,0,.561.54H9.945a1.138,1.138,0,0,1,.711.237l6.417,5.05a.567.567,0,0,0,.583.05.545.545,0,0,0,.307-.482V11.039a.545.545,0,0,0-.307-.482.567.567,0,0,0-.583.05l-6.417,5.05A1.118,1.118,0,0,1,9.967,15.9Z",
    transform: "translate(-1.134 -2.647)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M30,26.975a9.988,9.988,0,0,0,1.122-4.488A9.681,9.681,0,0,0,30,18",
    transform: "translate(-8.059 -4.922)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M34.5,29.207a14.288,14.288,0,0,0,2.244-7.853A14.04,14.04,0,0,0,34.5,13.5",
    transform: "translate(-9.287 -3.788)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M39,30.668a17.841,17.841,0,0,0,3.366-10.834A18,18,0,0,0,39,9",
    transform: "translate(-10.601 -2.269)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M0,0H35.13V35.131H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmMuteButton);
export default __webpack_public_path__ + "static/media/UmMuteButton.ba00c760040509f3aac924ce7899ead4.svg";
export { ForwardRef as ReactComponent };